export default __webpack_public_path__ + "static/media/arlechiney.8ae94b09.webp";